export default "__VITE_ASSET__C7CeD1vT__"